// extracted by mini-css-extract-plugin
export var promotionLink = "_uw-0";